var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPrint(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_55968_6763",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_55968_6763)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "print",
    d: "M13.3334 6.66667V4.16667H6.66669V6.66667H5.00002V2.5H15V6.66667H13.3334ZM15 10.4167C15.2361 10.4167 15.434 10.3368 15.5938 10.1771C15.7535 10.0174 15.8334 9.81944 15.8334 9.58333C15.8334 9.34722 15.7535 9.14931 15.5938 8.98958C15.434 8.82986 15.2361 8.75 15 8.75C14.7639 8.75 14.566 8.82986 14.4063 8.98958C14.2465 9.14931 14.1667 9.34722 14.1667 9.58333C14.1667 9.81944 14.2465 10.0174 14.4063 10.1771C14.566 10.3368 14.7639 10.4167 15 10.4167ZM13.3334 15.8333V12.5H6.66669V15.8333H13.3334ZM15 17.5H5.00002V14.1667H1.66669V9.16667C1.66669 8.45833 1.90974 7.86458 2.39585 7.38542C2.88196 6.90625 3.47224 6.66667 4.16669 6.66667H15.8334C16.5417 6.66667 17.1354 6.90625 17.6146 7.38542C18.0938 7.86458 18.3334 8.45833 18.3334 9.16667V14.1667H15V17.5ZM16.6667 12.5V9.16667C16.6667 8.93056 16.5868 8.73264 16.4271 8.57292C16.2674 8.41319 16.0695 8.33333 15.8334 8.33333H4.16669C3.93058 8.33333 3.73266 8.41319 3.57294 8.57292C3.41322 8.73264 3.33335 8.93056 3.33335 9.16667V12.5H5.00002V10.8333H15V12.5H16.6667Z",
    fill: "#5F5C71"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrint);
export default __webpack_public_path__ + "static/media/print.6f7dff4b33455717f1429d0160913429.svg";
export { ForwardRef as ReactComponent };